export class Size {
    constructor(width = 0, height = 1) {
        this.type = 'Size';
        this._width = width;
        this._height = height;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    static hydrate(data) {
        return new Size(data._width, data._height);
    }
}
